import React, { useState, useEffect } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import axios from 'axios';
import { CheckCircle, XCircle, Loader, Home, Heart } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import './DonationSuccessPage.css';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const DonationSuccessPage = () => {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');
  const [status, setStatus] = useState('checking'); // checking, success, failed
  const [paymentDetails, setPaymentDetails] = useState(null);
  const [attempts, setAttempts] = useState(0);

  useEffect(() => {
    if (sessionId) {
      pollPaymentStatus();
    } else {
      setStatus('failed');
    }
  }, [sessionId]);

  const pollPaymentStatus = async () => {
    const maxAttempts = 5;
    const pollInterval = 2000;

    if (attempts >= maxAttempts) {
      setStatus('failed');
      return;
    }

    try {
      const response = await axios.get(`${API}/payments/checkout/status/${sessionId}`);
      const data = response.data;

      if (data.payment_status === 'paid') {
        setStatus('success');
        setPaymentDetails(data);
        return;
      } else if (data.status === 'expired') {
        setStatus('failed');
        return;
      }

      // Continue polling
      setTimeout(() => {
        setAttempts(prev => prev + 1);
        pollPaymentStatus();
      }, pollInterval);

    } catch (error) {
      console.error('Error checking payment:', error);
      setStatus('failed');
    }
  };

  return (
    <>
      <Header />
      <div className="donation-success-page">
        <div className="success-container">
          {status === 'checking' && (
            <div className="status-content">
              <Loader className="spinner" size={60} />
              <h1>A verificar pagamento...</h1>
              <p>Por favor aguarde enquanto confirmamos o seu donativo.</p>
            </div>
          )}

          {status === 'success' && (
            <div className="status-content success">
              <CheckCircle size={80} className="success-icon" />
              <h1>Obrigado pelo seu donativo!</h1>
              <p>O seu pagamento foi processado com sucesso.</p>
              
              {paymentDetails && (
                <div className="payment-summary">
                  <div className="summary-row">
                    <span>Valor:</span>
                    <strong>{paymentDetails.amount?.toFixed(2)}€</strong>
                  </div>
                  <div className="summary-row">
                    <span>Estado:</span>
                    <strong className="paid">Pago</strong>
                  </div>
                </div>
              )}

              <p className="thank-you-message">
                A sua generosidade ajuda-nos a continuar o nosso trabalho de apoio 
                à saúde mental e bem-estar da comunidade. Muito obrigado!
              </p>

              <div className="success-actions">
                <Link to="/" className="btn-home">
                  <Home size={18} />
                  Voltar ao Início
                </Link>
              </div>
            </div>
          )}

          {status === 'failed' && (
            <div className="status-content failed">
              <XCircle size={80} className="failed-icon" />
              <h1>Pagamento não confirmado</h1>
              <p>
                Não foi possível confirmar o seu pagamento. 
                Se o valor foi debitado, por favor contacte-nos.
              </p>

              <div className="failed-actions">
                <Link to="/" className="btn-home">
                  <Home size={18} />
                  Voltar ao Início
                </Link>
              </div>
            </div>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default DonationSuccessPage;
